import React, { useState } from "react";
import { Button, Grid } from "semantic-ui-react";
import {
  getFullDate,
  getIsoWeekDate,
  getMonthYearDate,
} from "../../../js/helpers/dateHelpers";
import { getAuth } from "firebase/auth";
import { app } from "../../../app/config/firebase";
import { format, getDayOfYear } from "date-fns";

export default function AdminPanel() {
  const auth = getAuth(app);

  const [isLoading, setIsLoading] = useState(false);

  async function getUserToken() {
    setIsLoading(true);
    const user = auth.currentUser;

    const userToken = user && (await user.getIdToken());
    await navigator.clipboard.writeText(userToken);
    setIsLoading(false);
  }

  const dateToday = new Date();
  const dayOfYear = getDayOfYear(dateToday);
  const year = format(dateToday, "yy");

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={15} className="body-blue-text">
          <h2>Admin Panel</h2>
          <hr className="solid-divider" />
          <div className="statement">
            <span className="semi-bold">Date:</span>
            <span>
              {" "}
              {dayOfYear}
              {year} | {dateToday.toDateString()}
            </span>
          </div>
          <div className="statement">
            <span className="semi-bold">Week:</span>
            <span> dateIsoWeek - {getIsoWeekDate(dateToday)}</span>
          </div>
          <div className="statement">
            <span className="semi-bold">Month:</span>
            <span> dateMonthYear - {getMonthYearDate(dateToday)}</span>
          </div>
          <div className="statement">
            <span className="semi-bold">Today:</span>
            <span> dateFull - {getFullDate(dateToday)}</span>
          </div>
          <br />
          <Button
            className="overwrite-button cta-orange side-by-side-button"
            onClick={getUserToken}
            content={"Get token"}
            loading={isLoading}
          />
          {/*<Button*/}
          {/*  className="overwrite-button cta-orange side-by-side-button"*/}
          {/*  content={"Admin"}*/}
          {/*/>*/}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
